import script from "./toggle-switch.vue?vue&type=script&setup=true&lang=js"
export * from "./toggle-switch.vue?vue&type=script&setup=true&lang=js"

import "./toggle-switch.vue?vue&type=style&index=0&id=217bae48&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-217bae48"]])

export default __exports__